import React from "react";
import ReactDom from "react-dom";

import ChapterNavigationApp from "./ChapterNavigationApp.jsx";

export default function renderChapterNavigation() {
  const anchors =
    Array.from(document.querySelectorAll(".js-jump-nav-anchor")) || [];

  if (anchors.length <= 0) {
    return;
  }

  // There should only be one of these on the page
  // forEach is acting as an If statement
  document.querySelectorAll(".js-chapter-navigation-mount").forEach((mount) => {
    let index = 0;
    const label = mount.dataset.label || "Up Next:";

    const links = anchors.reduce((data, anchor) => {
      if (!anchor.textContent) {
        return data;
      }

      const target = anchor.id ? anchor.id : `jump-nav-anchor${index}`;
      anchor.setAttribute("data-index", index);
      anchor.setAttribute("id", target);

      data.push({
        label: anchor.textContent,
        index,
        href: `#${target}`,
      });

      index++;

      return data;
    }, []);

    ReactDom.render(
      <ChapterNavigationApp links={links} label={label} />,
      mount,
    );
  });
}
